import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import './ImageUploadButton.less';
import { useImageLibraryUploadHandler } from '../useImageLibraryUploadHandler';

export default function ImageUploadButton() {
  const { fileInputRef, handleClick, handleChange, accept } = useImageLibraryUploadHandler();

  return (
    <>
      <div
        style={{
          height: '100%',
          width: '100%',
          borderRadius: '4px',
        }}
        className="upload-button-container"
        onClick={handleClick}
        role="button"
      >
        <AddCircleOutlineIcon className="upload-button-icon" />
      </div>
      <input type="file" onChange={handleChange} ref={fileInputRef} accept={accept} hidden multiple data-testid="file-input" />
    </>
  );
}
